// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"366": "9154912f","427": "c6ecba09","654": "85176b3f","985": "482cb750",}[chunkId] + ".css"
}